import { createSlice } from "@reduxjs/toolkit";
import { status_slices } from "../../../../config/constants";



export const newReportsSlice = createSlice({
    name: 'newReports',
    initialState: {
        state: status_slices.WAITING,
        isLoading: false,
        msg: '',
        dateStart: '',
        dateEnd: '',
        servicesMaxMin: [],
        frecuency:[],
    },
    reducers: {
        processRequest: (state, action) => {
            state.isLoading = true;
            state.status = status_slices.PROCESSING;
        },
        notProcessRequest: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
        },
        clearMemory: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.dateStart = '';
            state.dateEnd = '';
            state.servicesMaxMin = [];
            state.frecuency = [];
        },
        setServicesMaxMin: (state, action) => {
            state.isLoading = false;
            state.msg = action.payload.msg;
            state.dateStart = action.payload.dateStart;
            state.dateEnd = action.payload.dateEnd;
            state.servicesMaxMin = action.payload.servicesMaxMin;
        },
        setServicesFrecuency: (state, action) => {
            state.isLoading = false;
            state.msg = action.payload.msg;
            state.dateStart = action.payload.dateStart;
            state.dateEnd = action.payload.dateEnd;
            state.frecuency = action.payload.frecuency;
        },

         setError: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.NOT_LOADED;
            state.msg = action.payload.msg;
            state.dateStart = '';
            state.dateEnd = '';
            state.servicesMaxMin = [];
            
        },
    }
});

export const { processRequest, notProcessRequest, clearMemory, setServicesMaxMin,setError,setServicesFrecuency } = newReportsSlice.actions;